import React from 'react';

export default function PartnerPortal() {
  return (
    <div style={{padding:16}}>
      <h2>Partner Portal</h2>
      <p>Run events, track prints, manage credits.</p>
      {/* Drop in your real components here (events table, credits, etc.) */}
    </div>
  );
}
